import React from 'react'
import { useTranslation } from 'react-i18next'

export const RoleTooltipContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={'grid grid-flex gap-m'}>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.role.propertyOwner.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.role.propertyOwner.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.role.tenant.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.role.tenant.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.role.agent.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.role.agent.description')}</span>
      </div>
    </div>
  )
}
